<script setup lang="ts">
import ForbiddenLogo from '@/assets/svg/ForbiddenLogo.svg'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const { t } = useI18n()
const router = useRouter()

const pickRandomMessage = () => {
  const messages = [t('error.unauthorisedOne'), t('error.unauthorisedTwo'), t('error.unauthorisedThree'), t('error.unauthorisedFour'), t('error.unauthorisedFive')]
  const index = Math.floor(Math.random() * messages.length)
  return messages[index] ?? '401'
}

const goBack = () => {
  if (globalThis.history.length > 2) {
    router.go(-2)
  } else {
    router.push('/')
  }
}
</script>

<template>
  <main>
    <div class="card p-fluid flex flex-col page-full overflow-hidden overflow-y-auto">
      <div class="flex-1 overflow-auto">
        <div class="card p-fluid">
          <div class="flex flex-column align-items-center justify-content-center">
            <img src="@/assets/allego_logo.svg" alt="logo" class="mr-2 w-2" data-cy="logo" />
            <divider />
            <Image :src="ForbiddenLogo" />
            <h1 class="text-500 text-3xl font-bold lg:text-5xl">{{ pickRandomMessage() }}</h1>
            <h1 class="text-900 text-sm font-bold">401</h1>
            <Button :label="t('general.goBack')" icon="pi pi-arrow-left" class="pl-4 pr-4" @click="goBack" severity="contrast" />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
